"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeywordTag = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
require("@/components/common/tag/tag");
const tag_utils_1 = require("@/components/common/tag/tag.utils");
let KeywordTag = class KeywordTag extends lit_1.LitElement {
    render() {
        return (0, tag_utils_1.renderTag)('default', this.icon);
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: String })
], KeywordTag.prototype, "icon", void 0);
KeywordTag = __decorate([
    (0, decorators_js_1.customElement)('mm-keyword-tag')
], KeywordTag);
exports.KeywordTag = KeywordTag;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoia2V5d29yZC10YWcuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJrZXl3b3JkLXRhZy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFBQSw2QkFBZ0M7QUFDaEMscURBQTJEO0FBSTNELHVDQUFvQztBQUNwQyxpRUFBNkQ7QUFHdEQsSUFBTSxVQUFVLEdBQWhCLE1BQU0sVUFBVyxTQUFRLGdCQUFVO0lBR3hDLE1BQU07UUFDSixPQUFPLElBQUEscUJBQVMsRUFBQyxTQUFTLEVBQUUsSUFBSSxDQUFDLElBQUksQ0FBQyxDQUFBO0lBQ3hDLENBQUM7Q0FDRixDQUFBO0FBTDZCO0lBQTNCLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxNQUFNLEVBQUUsQ0FBQzt3Q0FBZ0I7QUFEaEMsVUFBVTtJQUR0QixJQUFBLDZCQUFhLEVBQUMsZ0JBQWdCLENBQUM7R0FDbkIsVUFBVSxDQU10QjtBQU5ZLGdDQUFVIn0=